export const jotr2026Schedule = [
  {
    date: "2026-07-18",
    time: "12:00-20:00",
    activity: "Racepack Collection All Category",
    location: "Decathlon JKT",
    event: "JOTR",
    categories: ["all"],
  },
  {
    date: "2026-07-19",
    time: "12:00-20:00",
    activity: "Racepack Collection All Category",
    location: "Decathlon JKT",
    event: "JOTR",
    categories: ["all"],
  },
  {
    date: "2026-07-24",
    time: "07:00-08:00",
    activity: "Check-in & Accreditation (SEATRC)",
    location: "TNGGP Hall",
    event: "SEATRC",
  },
  {
    date: "2026-07-24",
    time: "08:00-10:00",
    activity: "Opening Ceremony & Nation Parade",
    location: "TNGGP Hall",
    event: "SEATRC",
  },
  {
    date: "2026-07-24",
    time: "09:00-18:00",
    activity: "Racepack Collection & Medical Check",
    location: "TNGGP Hall",
    event: "JOTR",
    categories: ["75"],
  },
  {
    date: "2026-07-24",
    time: "10:00-11:30",
    activity: "Technical Meeting",
    location: "TNGGP Hall",
    event: "SEATRC",
  },
  {
    date: "2026-07-24",
    time: "14:00-14:30",
    activity: "Call Room Open & Close Vertical Category",
    location: "Cibodas",
    event: "SEATRC",
  },
  {
    date: "2026-07-24",
    time: "15:00",
    activity: "Flag Off Uphill Vertical 7K (SEATRC)",
    location: "Cibodas",
    event: "SEATRC",
  },
  {
    date: "2026-07-24",
    time: "15:00-16:00",
    activity: "Press Conference",
    location: "TBC",
    event: "SEATRC",
  },
  {
    date: "2026-07-24",
    time: "16:00-17:00",
    activity: "Technical Meeting 75K & 42K",
    location: "TNGGP Hall",
    event: "JOTR",
    categories: ["75", "42"],
  },
  {
    date: "2026-07-24",
    time: "17:00",
    activity: "Cut Off Time Uphill Vertical 7K",
    location: "Kd Badak",
    event: "SEATRC",
  },
  {
    date: "2026-07-25",
    time: "00:01-00:30",
    activity: "Call Room Open & Close Long Trail",
    location: "Cibodas",
    event: "SEATRC",
  },
  {
    date: "2026-07-25",
    time: "01:00",
    activity: "Flag Off Long Trail 75K (SEATRC)",
    location: "Cibodas",
    event: "SEATRC",
  },
  {
    date: "2026-07-25",
    time: "01:10",
    activity: "Flag Off Ultra Trail 75K (JOTR)",
    location: "Cibodas",
    event: "JOTR",
    categories: ["75"],
  },
  {
    date: "2026-07-25",
    time: "03:00-03:30",
    activity: "Call Room Open & Close Short Trail",
    location: "Cibodas",
    event: "SEATRC",
  },
  {
    date: "2026-07-25",
    time: "04:00",
    activity: "Flag Off Short Trail 42K (SEATRC)",
    location: "Cibodas",
    event: "SEATRC",
  },
  {
    date: "2026-07-25",
    time: "04:10",
    activity: "Flag Off Full Marathon 42K (JOTR)",
    location: "Cibodas",
    event: "JOTR",
    categories: ["42"],
  },
  {
    date: "2026-07-25",
    time: "10:00-18:00",
    activity: "Racepack Collection & Medical Check",
    location: "TNGGP Hall",
    event: "JOTR",
    categories: ["21", "10", "5"],
  },
  {
    date: "2026-07-25",
    time: "10:00",
    activity: "COP Long Trail & Short Trail (SEATRC)",
    location: "Selabintana",
    event: "SEATRC",
  },
  {
    date: "2026-07-25",
    time: "14:00",
    activity: "Cut Off Time Short Trail 42K (SEATRC)",
    location: "Cibodas",
    event: "SEATRC",
  },
  {
    date: "2026-07-25",
    time: "14:10",
    activity: "COP Ultra Trail & Full Marathon (JOTR)",
    location: "Selabintana",
    event: "JOTR",
    categories: ["75", "42"],
  },
  {
    date: "2026-07-25",
    time: "16:00-17:00",
    activity: "Technical Meeting 21K, 10K & 5K",
    location: "TNGGP Hall",
    event: "JOTR",
    categories: ["21", "10", "5"],
  },
  {
    date: "2026-07-25",
    time: "19:00",
    activity: "Cut Off Time Long Trail 75K (SEATRC)",
    location: "Cibodas",
    event: "SEATRC",
  },
  {
    date: "2026-07-25",
    time: "20:10",
    activity: "Cut Off Time Full Marathon 42K (JOTR)",
    location: "Cibodas",
    event: "JOTR",
    categories: ["42"],
  },
  {
    date: "2026-07-26",
    time: "02:10",
    activity: "Cut Off Time Ultra Trail 75K (JOTR)",
    location: "Cibodas",
    event: "JOTR",
    categories: ["75"],
  },
  {
    date: "2026-07-26",
    time: "05:00",
    activity: "Flag Off Half Marathon 21K (JOTR)",
    location: "Cibodas",
    event: "JOTR",
    categories: ["21"],
  },
  {
    date: "2026-07-26",
    time: "05:00-05:30",
    activity: "Call Room Open & Close Mountain Classic (SEATRC)",
    location: "Cibodas",
    event: "SEATRC",
  },
  {
    date: "2026-07-26",
    time: "06:00",
    activity: "Flag Off Mountain Classic 10K - Male",
    location: "Cibodas",
    event: "SEATRC",
  },
  {
    date: "2026-07-26",
    time: "06:10",
    activity: "Flag Off Mountain Classic 10K - Female",
    location: "Cibodas",
    event: "SEATRC",
  },
  {
    date: "2026-07-26",
    time: "07:00",
    activity: "Flag Off 10K (JOTR)",
    location: "Cibodas",
    event: "JOTR",
    categories: ["10"],
  },
  {
    date: "2026-07-26",
    time: "07:30",
    activity: "Flag Off 5K (JOTR)",
    location: "Cibodas",
    event: "JOTR",
    categories: ["5"],
  },
  {
    date: "2026-07-26",
    time: "08:00",
    activity: "Cut Off Time Mountain Classic 10K - Male",
    location: "Cibodas",
    event: "SEATRC",
  },
  {
    date: "2026-07-26",
    time: "08:10",
    activity: "Cut Off Time Mountain Classic 10K - Female",
    location: "Cibodas",
    event: "SEATRC",
  },
  {
    date: "2026-07-26",
    time: "09:00",
    activity: "Closing Ceremony and Award SEATRC",
    location: "Cibodas",
    event: "SEATRC",
  },
  {
    date: "2026-07-26",
    time: "09:00",
    activity: "COP Half Marathon 21K (JOTR)",
    location: "Kd Badak",
    event: "JOTR",
    categories: ["21"],
  },
  {
    date: "2026-07-26",
    time: "10:00",
    activity: "Cut Off Time 5K (JOTR)",
    location: "Cibodas",
    event: "JOTR",
    categories: ["5"],
  },
  {
    date: "2026-07-26",
    time: "10:30",
    activity: "Cut Off Time 10K (JOTR)",
    location: "Cibodas",
    event: "JOTR",
    categories: ["10"],
  },
  {
    date: "2026-07-26",
    time: "12:00",
    activity: "Podium Ceremony 5K, 10K, 21K, 42K & 75K",
    location: "Cibodas",
    event: "JOTR",
    categories: ["all"],
  },
  {
    date: "2026-07-26",
    time: "15:00",
    activity: "Cut Off Time Half Marathon 21K (JOTR)",
    location: "Cibodas",
    event: "JOTR",
    categories: ["21"],
  },
  {
    date: "2026-07-26",
    time: "15:30",
    activity: "Closing Ceremony",
    location: "Cibodas",
    event: "JOTR",
    categories: ["all"],
  },
];

const resolveCategoryKey = (category = {}) => {
  const name = String(category.categoryName || "").toLowerCase();
  const distance = Number(category.distance);

  if (name.includes("75") || distance === 75) return "75";
  if (name.includes("42") || distance === 42) return "42";
  if (name.includes("21") || distance === 21) return "21";
  if (name.includes("10") || distance === 10) return "10";
  if (name.includes("5") || distance === 5) return "5";
  return String(distance || "");
};

export const getJotr2026CategoryRundown = (category) => {
  const categoryKey = resolveCategoryKey(category);

  return jotr2026Schedule.filter(
    (entry) =>
      entry.categories?.includes("all") ||
      entry.categories?.includes(categoryKey),
  );
};

const getStartMinutes = (time) => {
  const startTime = String(time || "").split("-")[0].trim();
  const [hours, minutes] = startTime.split(":").map(Number);

  if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;
  return hours * 60 + minutes;
};

export const getJotr2026CategoryScheduleDetails = (category) => {
  const categoryKey = resolveCategoryKey(category);
  const categorySchedule = jotr2026Schedule.filter(
    (entry) =>
      entry.event === "JOTR" && entry.categories?.includes(categoryKey),
  );
  const flagOff = categorySchedule.find((entry) =>
    entry.activity.toLowerCase().includes("flag off"),
  );
  const cutOff = categorySchedule.find((entry) =>
    entry.activity.toLowerCase().includes("cut off time"),
  );

  if (!flagOff) return {};

  const details = {
    date: flagOff.date,
    time: String(flagOff.time).split("-")[0].trim(),
  };
  const flagOffMinutes = getStartMinutes(flagOff.time);
  const cutOffMinutes = getStartMinutes(cutOff?.time);

  if (cutOff && flagOffMinutes != null && cutOffMinutes != null) {
    const startDate = new Date(`${flagOff.date}T00:00:00`);
    const cutOffDate = new Date(`${cutOff.date}T00:00:00`);
    const dayDifference = Math.round(
      (cutOffDate.getTime() - startDate.getTime()) / 86_400_000,
    );
    details.cot =
      (dayDifference * 24 * 60 + cutOffMinutes - flagOffMinutes) / 60;
  }

  return details;
};

export const getJotr2026CategoryMapUrl = (category) => {
  const categoryKey = resolveCategoryKey(category);
  const supportedCategories = new Set(["5", "10", "21", "42", "75"]);

  if (!supportedCategories.has(categoryKey)) return null;

  return `https://gpxmap-cakrawala.web.app/jotr2026-${categoryKey}/`;
};

export const formatScheduleDate = (date) =>
  new Date(`${date}T00:00:00`).toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });
